import Home from '../../views/home/Home.vue'

export default {
    path: '/',
    name: "Home",
    component: Home
}